module.exports = __webpack_public_path__ + "img/logo.383f0e73.png";